UC = UC || {};
UC.timesheetComponent = UC.timesheetComponent || {};

UC.timesheetComponent.TimesheetJob = Backbone.Model.extend({
  idAttribute: '_id'
});
